const HIDE_MESSAGE = 'HIDE_MESSAGE';
const DISPLAY_MESSAGE = 'DISPLAY_MESSAGE';

export const INFO = 'info';
export const SUCCESS = 'success';
export const WARNING = 'warning';

export const hideMessage = () => ({
  type: HIDE_MESSAGE,
});

export const displayMessage = (icon, text, type = INFO, duration = 5000) => ({
  type: DISPLAY_MESSAGE,
  payload: {
    message: {
      icon,
      text,
      type,
      duration,
    },
  },
});


const initialState = {
  hidden: true,
  icon: '',
  text: '',
  type: '',
  duration: 5000,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case HIDE_MESSAGE: {
      return initialState;
    }
    case DISPLAY_MESSAGE: {
      return {
        ...action.payload.message,
        hidden: false,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./book/src/commons/components/message/messageDucks.js